import React, { lazy, useEffect } from 'react'
import { useFeatureFlagVariantKey } from '@posthog/react'
import posthog from 'posthog-js'
import Sherpa, { TYPE_LARGE } from '../Sherpa/index'
import { POSTHOG_FEATURE_FLAGS } from '../PostHog/index'

const LoadableSearch = lazy(
  () => import('../SearchPage/index'),
  { fallback: <Sherpa type={TYPE_LARGE} /> },
)

export default function SearchPageSwitch (props) {
  const aiSearchVariant = useFeatureFlagVariantKey(
    POSTHOG_FEATURE_FLAGS.AI_SEARCH_WEB,
  )

  // Track experiment exposure for the AI Search A/B test.
  // Both test and control users render the same SearchPage — the PostHog
  // flag gates the AI overview visibility inside the component.
  useEffect(() => {
    if (aiSearchVariant && (aiSearchVariant === 'test' || aiSearchVariant === 'control')) {
      posthog.capture('experiment_exposure', {
        '$feature/ai-search-web': aiSearchVariant,
        experiment: 'ai-search-web',
      })
    }
  }, [aiSearchVariant])

  return <LoadableSearch location={props.location} history={props.history} />
}
